module.exports = __webpack_public_path__ + "img/img18.48b3fb4e.jpg";